module.exports = __webpack_public_path__ + "static/media/purepapercolor.85222df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections/purepapercolor.jpg
// module id = 1150
// module chunks = 37